import { render, staticRenderFns } from "./featured-book.vue?vue&type=template&id=f84715b4&scoped=true&"
import script from "./featured-book.vue?vue&type=script&lang=js&"
export * from "./featured-book.vue?vue&type=script&lang=js&"
import style0 from "./featured-book.vue?vue&type=style&index=0&id=f84715b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84715b4",
  null
  
)

export default component.exports